import { useMutation } from '@tanstack/react-query';
import { getMainAndAroundODB } from '../api/client';

export const useGetMainAndAroundODB = () => {
    const { mutateAsync: fetchMainAndAroundODB } = useMutation({
        mutationFn: ({ lat, lng, range }: { lat: number, lng: number, range?: number }) => {
            return getMainAndAroundODB({ lat, lng, range });
        },
    });
    return fetchMainAndAroundODB;
}